'use client';
import React from 'react';
import { Button, Div, Text } from '@pezeshk-book/ui-kit';
import { LaboratoryActions } from '@store/lab/lab-actions';
import { useDispatch } from 'react-redux';

const CoronaHome = ({ coronaSlug, labs, translate, buttonTitle } : {coronaSlug: string, labs: Array<{slug: string, id: string}>, translate: {corona: any, hpv: any}, buttonTitle: string}) => {
  const dispatch = useDispatch();
  const handleSetServiceType = ({ slug } : {slug: string}) => {
    const lab = labs.find(value => value.slug === slug);
    dispatch(LaboratoryActions.setShoppingCartInitialState());
    dispatch(LaboratoryActions.setCityModal({ labId: lab?.id, slug: lab?.slug, open: true }));
  };

  return (
    <Div className={'flex-col md:gap-[72px] gap-8'}>
      <Div className={'flex-col md:gap-8 gap-2'}>
        <Text color={'tertiary'} type={'bold'} typography={'xl'} align={'start'}>
          {translate.corona.title}
        </Text>
        <Text color={'grey.800'} align={'justify'}>
          {translate.corona.description}
        </Text>
        <Div className={'w-full sm:w-[456px] self-center md:w-[636px]'}>
          <Button onClick={() => handleSetServiceType({ slug: coronaSlug })} fontType={'bold'} size={'large'} className={'w-full'}>
            {buttonTitle}
          </Button>
        </Div>
      </Div>
      <Div className={'flex-col md:gap-8 gap-2'}>
        <Text color={'tertiary'} type={'bold'} typography={'xl'} align={'start'}>
          {translate.hpv.title}
        </Text>
        <Text color={'grey.800'} align={'justify'}>
          {translate.hpv.description}
        </Text>
        <Div className={'w-full sm:w-[456px] self-center md:w-[636px]'}>
          <Button disabled={true} size={'large'} fontType={'bold'} className={'w-full'}>
            {buttonTitle}
          </Button>
        </Div>
      </Div>
    </Div>
  );
};

export default CoronaHome;
